module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "",
    attrs: {
      "id": ""
    }
  }, [_c('table', {
    ref: "idVerList",
    staticClass: "CFTable",
    staticStyle: {
      "float": "left",
      "width": "760px",
      "margin-left": "10px",
      "margin-top": "10px"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a4be7978","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/aiphoto/verSelect.vue
// module id = 805
// module chunks = 1